<template>
  <c-view>
    <c-page class="page-color">
      <c-navbar></c-navbar>
      <c-content>
        <div class="tickets">
          <div class="ticket" 
                v-for="item in tickets"
                :key="item"
               :class="[(operationType==operationTypeEnum.select||item.useable) ? 'primary':'']"
               @click="itemClick(item)">
            <div class="part-1">
              <p class="price">
                <sup>￥</sup>
                {{ item.price }}
              </p>
            </div>
            <div class="line"></div>
            <div class="part-2">
              <div class="info">
                <div class="title">{{ item.title }}</div>
                <ul class="desc">
                  <li v-for="desc in item.descs" :key="desc">{{ desc }}</li>
                </ul>
              </div>
              <div class="operation" v-if="operationType == operationTypeEnum.click">领取</div>
              <div class="operation select" v-if="operationType == operationTypeEnum.select">
                <i class="weui-icon-success" v-if="selectItem == item"></i>
                <i class="weui-icon-circle" v-else></i>
              </div>
            </div>
          </div>
        </div>
      </c-content>
    </c-page>
  </c-view>
</template>
<style lang="scss" scoped>
  @import "./index";
</style>
<script>
  import Ticket from '../../model/tickets'
  import * as StoreTypes from '../../store/mutation-types'
  export default{
    props: {},
    data () {
      return {
        operationTypeEnum: {
          click: 'click',
          select: 'select'
        },
        ticketObj: new Ticket(),
        operationType: 'click',
        selectItem: null
      }
    },
    components: {},
    created () {},
    mounted () {
      if (this.$route.path.indexOf('/selectGoodsTicket') !== -1) {
        this.operationType = this.operationTypeEnum.select
      }
    },
    beforeDestroy () {},
    methods: {
      itemClick (itemObj) {
        // 选择逻辑
        if (this.operationType === this.operationTypeEnum.select) {
          this.selectItem = this.selectItem === itemObj ? null : itemObj
          this.$bus.$emit('couponSelected', itemObj)
          this.$router.back()
          return
        }
        // 领取逻辑
        if (!itemObj.useable) return
        this.ticketObj.takeTicket(itemObj.id)
      }
    },
    computed: {
      tickets () {
        let proc = {
          [this.operationTypeEnum.click]: 'getTicketList',
          [this.operationTypeEnum.select]: StoreTypes.ORDER_TICKET
        }
        return this.$store.getters[proc[this.operationType]]
      }
    },
    events: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?854b94ac